import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const Nettoyage = () => {
  const sectorData = {
    title: "Nettoyage",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Dans le nettoyage industriel ou tertiaire, les décideurs cherchent des prestataires fiables, transparents et efficaces. Proposer des offres claires, des audits de sites et des cas clients en multi-sites est stratégique pour se différencier.",
    name: "Nettoyage",
    titleContext: "du secteur du nettoyage",
    responseContext: "du secteur du nettoyage",
    expertContext: "du secteur du nettoyage"
  };

  return <SectorPage sector={sectorData} />;
};

export default Nettoyage; 